import _ from 'lodash';
import {
  createSelectorCreator,
  defaultMemoize,
  createSelector,
} from 'reselect';

/**
 * Create a "selector creator" that uses lodash.isEqual instead of === as the returned value for manualInputsSelector/inputsSelector
 * As they don't return a calculated values (it returns an object), so on each render equality check (=== by default) will fail
 */
const createDeepEqualSelector = createSelectorCreator(
  defaultMemoize,
  _.isEqual
);

const homeAffordabilitySelector = (state) => state.results;

export const manualInputsSelector = createDeepEqualSelector(
  homeAffordabilitySelector,
  (homeAffordability) => homeAffordability.manualInputs
);

export const inputsSelector = createDeepEqualSelector(
  homeAffordabilitySelector,
  (homeAffordability) => homeAffordability.inputs
);

export const overridesSelector = createDeepEqualSelector(
  homeAffordabilitySelector,
  (homeAffordability) => homeAffordability.overrides
);

export const outputsSelector = createDeepEqualSelector(
  homeAffordabilitySelector,
  (homeAffordability) => homeAffordability.outputs
);

export const adjustedOutputsSelector = createDeepEqualSelector(
  homeAffordabilitySelector,
  (homeAffordability) => homeAffordability.adjustedOutputs
);
export const hasLinkedCreditScoreSelector = createSelector(
  homeAffordabilitySelector,
  (homeAffordability) => homeAffordability.hasLinkedCreditScoreSelector
);
